module.exports = __webpack_public_path__ + "img/expertise_default.43d5458b.png";